// extracted by mini-css-extract-plugin
export var caption = "video-promo-module--caption--MWDyS";
export var componentMargin = "video-promo-module--componentMargin--P0r57";
export var coverImage = "video-promo-module--coverImage--8FLKn";
export var headline = "video-promo-module--headline--76o1t";
export var leftAlign = "video-promo-module--leftAlign--dw-H7";
export var summary = "video-promo-module--summary--vTMX6";
export var videoPromo = "video-promo-module--videoPromo--km-fl";